var _style, _g;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgEliminar = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 55 55",
    style: {
      enableBackground: "new 0 0 55 55"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#517ED3;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WEVjhE.tif_00000119093438099705827470000010918393551806326179_",
    transform: "translate(25.617 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_353_00000145025560826413162970000013614652887403010213_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_614_00000096780090749921391730000014499536755224403095_",
    className: "st0",
    d: "M-10.9,5.2c1.2-1,2.3-1,3.1-0.2 S-7.1,6.9-8,8.1c0.8,0.8,1.6,1.6,2.4,2.4c0.3,0.2,0.4,0.7,0.2,1c0,0,0,0.1-0.1,0.1c-0.3,0.2-0.6,0.3-0.9,0.3 c-0.1,0-0.3-0.2-0.4-0.3c-2.5-2.5-5.1-5.1-7.6-7.6c-0.4-0.3-0.4-0.8-0.1-1.2c0,0,0,0,0-0.1c0.4-0.3,0.9-0.3,1.3,0.1c0,0,0,0,0,0 C-12.5,3.6-11.7,4.4-10.9,5.2z M-10.2,5.8l1.5,1.5c0.1-0.4,0.4-0.7,0.4-1C-8.4,5.9-8.7,5.7-9,5.5C-9.3,5.5-9.7,5.7-10.2,5.8 L-10.2,5.8z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_352_00000036213696812891983920000017871333147985398460_",
    transform: "translate(0 5.147)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_615_00000156589798824579660600000012746118145589877683_",
    className: "st0",
    d: "M-11.5,3.8c-2.6,0-5.1,0-7.7,0 c-0.8-0.1-1.6,0.5-1.7,1.4c0,0.2,0,0.4,0,0.6c0.4,3.4,0.9,6.7,1.3,10.1c0,0.9,0.8,1.6,1.7,1.6c0,0,0,0,0,0c0.8,0,1.6,0,2.4,0 c0.8,0,1.7,0,2.5,0c0.9,0.1,1.7-0.6,1.7-1.5c0,0,0,0,0,0c0.4-3.3,0.9-6.6,1.3-9.9C-9.6,4.5-10.1,3.8-11.5,3.8z M-17.1,15.9 c-0.7,0.1-1.3-0.5-1.4-1.2c0,0,0,0,0,0c-0.4-2.6-0.7-5.2-1.1-7.9c-0.2-0.6,0.2-1.3,0.9-1.5c0.1,0,0.3,0,0.4,0c0.6,0,1.7,0,2.4,0 l0.3,10.6C-15.9,15.9-16.8,15.9-17.1,15.9L-17.1,15.9z M-10.9,6.9c-0.3,2.6-0.7,5.2-1,7.8c0,0.7-0.6,1.2-1.3,1.2c0,0,0,0,0,0 c-0.3,0-1.2,0-1.6,0l0.3-10.6c0.6,0,1.7,0,2.3,0C-11.2,5.3-10.7,5.8-10.9,6.9L-10.9,6.9z"
  }))))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEliminar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Eliminar.78ccbb62.svg";
export { ForwardRef as ReactComponent };